import styled from "styled-components";
import { Box, Breadcrumbs, Button, Tooltip } from "@mui/material";

export const Container = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding: 25px;
  max-width: 750px;
  align-items: center;
`;

export const Image = styled.img`
  margin-right: 15px;
`;

export const TempBreadcrumb = styled.div`
  > a {
    color: ${({ theme }) => theme.palette.text.secondary};
  }
  > strong {
    font-size: 20px;
  }
`;

export const TopContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1000px) {
    align-items: start;
    flex-direction: column;
  }
`;

export const TopLeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TopRightContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const PillContainer = styled.div<{ isOpen: boolean }>`
  border-radius: 25px;
  padding: 6px 12px;
  border: 1px solid
    ${({ isOpen, theme }) =>
      isOpen ? theme.palette.success.main : theme.palette.error.main};
`;

export const ActionsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 15px;
`;

export const ContentStatus = styled(Box)`
  margin-top: 25px;
  margin-bottom: 25px;
  background-color: #f5f5f5;
  height: 70px;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonIcon = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 16px !important;
  background: #d33100 !important;
  height: 42px;
  border-radius: 21px !important;
  border: solid 1px #d33100;
  cursor: pointer;
  color: #ffffff !important;
`;

export const ButtonSecondary = styled(Button)`
  display: flex;
  background: none;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 16px !important;
  height: 42px;
  border-radius: 21px !important;
  border: solid 1px #000000 !important;
  cursor: pointer;
  color: #000000 !important;
  gap: 6px;
`;

export const BreadcrumbsContainer = styled(Breadcrumbs)`
  flex-direction: column;

  div {
    min-width: 265px;
  }
`;

export const ContainerFlex = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1000px) {
    margin-top: 25px;
    align-items: start;
  }
`;

export const ContainerPhone = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 25px;
`;

export const ContainerNotRegister = styled.div`
  height: 24px;
  border-radius: 12px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContainerSuperRecolhe = styled.div`
  display: flex;
  flex-direction: column;
  margin: 32px 0 48px 0;
  gap: 16px;
`;

export const ServicesContainer = styled.div`
  width: 100%;
  gap: 16px;
`;

export const ServicesButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  gap: 16px;
`;

export const SuperRecolheEditContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-self: flex-end;
`;

export const ServicesListContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const ServicesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ServicesTooltip = styled(Tooltip)`
  margin-left: 8px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const getServicesTooltipSlotProps = () => ({
  tooltip: {
    sx: {
      fontFamily: '"Gotham", sans-serif',
      fontSize: 16,
      lineHeight: "24px",
      backgroundColor: "#202224",
      color: "#F2F4F7",
      borderRadius: 8,
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.12)",
      padding: "16px",
      textAlign: "left",
      maxWidth: "300px",
    },
  },
});
